export default __webpack_public_path__ + "static/media/danger.6e768031.svg";